<template>
    <v-card>
        <v-card-title class="accent white--text title">
            Chilled Water Supply Setpoint Benefit Analysis
        </v-card-title>
        <v-card-text>
            <v-slider
                    v-model="targetTemp"
                    thumb-label="always"
                    label="Chilled Water Return Target (deg C)"
                    max="25"
                    min="5"
                    step="0.1"
            ></v-slider>
        </v-card-text>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <value-box :value="saving" unit="kWh"
                               icon-class="mr-3"
                               title="Potential Saving" icon="fa-piggy-bank"></value-box>
                </v-flex>
                <v-flex xs12 md6>
                    <value-box :value="savingMoney"
                               icon-class="mr-3"
                               :unit="$store.state.pointsListStore.pointsList.currency"
                               title="Potential Saving"
                               icon="fa-piggy-bank">
                    </value-box>
                </v-flex>
                <v-flex xs12 md6>
                    <value-box :value="currentUsage"
                               icon-class="mr-4 ml-4"
                               unit="kWh" title="Current Usage" icon="fa-bolt"></value-box>
                </v-flex>
                <v-flex xs12 md6>
                    <value-box :value="currentUsageMoney"
                               icon-class="mr-4 ml-4"
                       :unit="$store.state.pointsListStore.pointsList.currency"
                       title="Current Usage" icon="fa-bolt"></value-box>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

    <script>
    import {getControlLogicBenefits} from '@/helper'
    import debounce from 'lodash.debounce'
    import ValueBox from './ValueBox'

      export default {
        name: 'ControlLogicChilledWaterSP',
        components: { ValueBox },
        props: {
          equipment: {type: String},
          range: {type: Object, default: null}
        },
        data() { return {
          targetTemp: 13.0,
          saving: null,
          currentUsage: null,
          savingMoney: null,
          currentUsageMoney: null
        }
        },
        watch: {
          equipment () {
            this.refresh()
          },
          targetTemp () {
            this.refresh()
          },
          range () {
            this.refresh()
          }
        },
        methods: {
          refresh: debounce(
            function run() {
              this.refreshFunc()
            },
            500
          ),
          async refreshFunc () {
            this.$store.dispatch('callSnackbar', {text: 'Computing Saving'})
            this.saving = null
            let result = await getControlLogicBenefits(
              {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'equipment_name': this.equipment,
                'target_CHWR_Temp': parseFloat(this.targetTemp),
                'date_range': this.range
              }
            )
            this.saving = result.Saving_Electricity&&result.Saving_Electricity.length>0 ? result.Saving_Electricity.reduce((a,b)=>a+b).toFixed(2)/this.$store.state.pointsListStore.pointsList.sampling_freq : 0
            this.savingMoney = this.saving * this.$store.state.pointsListStore.pointsList.electricityPrice[this.equipment]
            this.currentUsage = result.Comp_Power&&result.Comp_Power.length>0 ? result.Comp_Power.reduce((a,b)=>a+b).toFixed(2)/this.$store.state.pointsListStore.pointsList.sampling_freq: 0
            this.currentUsageMoney = this.currentUsage * this.$store.state.pointsListStore.pointsList.electricityPrice[this.equipment]
          }

        }
      }
</script>

<style scoped>

</style>
